export enum DefaultBooleanChoiceOrderEnum {
  TRUE_THEN_FALSE = 'TRUE_THEN_FALSE',
  FALSE_THEN_TRUE = 'FALSE_THEN_TRUE'
}
